import { useEffect, useState } from "react";
import MenuApp from "@menu/app";
import { observer, useLocalObservable } from "mobx-react-lite";
import TvGuideStore from "core/providers/tv-guide.store";
import { AppContextProvider } from "core/providers/tv-guide.context";
import DataManager from "core/providers/data.manager";
import { useEffectOnce } from "@menu/core/hooks";
import { LayoutType } from "core/constants";
import TvGuide from "components/tv-guide";
import { intervalTimeUpdate } from "core/lib/time-methods";

const store = new TvGuideStore();

const minimumWidthForGrid = 1000;

type AppProps = {
  hideMenu?: boolean
}

const App = observer((props: AppProps) => {
  const { hideMenu = false } = props;

  const dataManager = useLocalObservable(() => new DataManager(store));
  const [isError, setIsError] = useState(false);

  useEffectOnce(() => {
    const load = async () => await dataManager.populate();

    try {
      load();

      const setTime = () => {
        store.updateCurrentTime();
      }

      intervalTimeUpdate(setTime);
    } catch (error) {
      setIsError(true);
    }
  });

  const handleResize = () => {
    const windowWidth = document.body.getBoundingClientRect().width;
    const type = windowWidth >= minimumWidthForGrid ? LayoutType.grid : LayoutType.list;

    dataManager.store.updateLayout(type);
  }

  useEffect(() => {
    // Debounce resize function, only calls the function after resize stops for 300ms
    let timeout: NodeJS.Timeout;

    window.addEventListener("resize", () => {
      function delayed() {
        handleResize();
      }

      if (timeout) {
        clearTimeout(timeout);
      } else {
        handleResize();
      }

      timeout = setTimeout(delayed, 300);
    });
  }, []);

  if (isError) {
    return <h1>Error</h1>
  }

  return (
    <>
      {!hideMenu && <div id="root">
        <MenuApp />
      </div>}

      <div className="tvg-master-container">
        <AppContextProvider dataManager={dataManager}>
          <TvGuide store={store} />
        </AppContextProvider>
      </div>
    </>
  );
});

export default App;
